<template>
  <div class="d-flex text-muted" style="align-items: center;">
    <v-icon small class="me-2">{{ icon }}</v-icon>
    {{ message }}
    <slot />
    <v-spacer />
    <v-btn v-if="to || href" text small :href="href" :target="href?'_blank':null" :to="to">{{ linkText || $t('shared.learn-more') }}</v-btn>
  </div>  
</template>

<script>

export default {
  name: "InlineTip",
  props: {
    message: String,
    icon: {
      type: String,
      default: 'fa-lightbulb-on',
    },
    color: {
      type: String,
      default: null,
    },
    small: {
      type: Boolean,
      default: true,
    },
    linkText: String,
    to: Object,
    href: String,
  },
  components: {
  },
  data: function() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
  computed: {
  },
};
</script>

<style scoped>
</style>